import { State, Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

/**
 *
 * @param store the current store value
 * @param x *optional: explicitly return this state property EX: user, payment, application
 */
export const getState = (store: Store<any>, x?: string): State<any> => {
    try {
        let state: State<any>;
        store.pipe(take(1)).subscribe(s => (state = s));
        if (x) {
            // if property is passed
            if (state[x]) {
                return state[x];
            } else {
                return state;
            }
        } else {
            // if no property is passed
            return state;
        }
    } catch (e) {
        return null;
    }
};
